<template>
  <div>
    <reset-password-form />
  </div>
</template>

<script>
import resetPasswordForm from "../components/login/ResetPasswordForm";

export default {
  components: {
    resetPasswordForm
  }
};
</script>
